// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ProgressBar-module__wrapper--3e7gX{box-sizing:border-box;padding:1.722rem 0;width:100%}.ProgressBar-module__outerBar--20Yac{background:#d5d5e2;border-radius:0.389rem;height:0.778rem;margin:auto;max-width:30.444rem;overflow:hidden;width:100%}.ProgressBar-module__innerBar--3mRcB{background:linear-gradient(90deg, #0050ff 70%, #2569fd 96%);height:0.778rem;width:0}\n", ""]);
// Exports
exports.locals = {
	"wrapper": "ProgressBar-module__wrapper--3e7gX",
	"outerBar": "ProgressBar-module__outerBar--20Yac",
	"innerBar": "ProgressBar-module__innerBar--3mRcB"
};
module.exports = exports;
